import resetMixin from '@/helper/resetForm'
import axios from 'axios'
import tokenClear from '@/helper/eraseToken'

export const spt = {
    mixins: [resetMixin, tokenClear],
    methods: {
        // store data
        async store () {
            try {
                this.helper.isLoading = true
                // data form di ambil dari views/transaksi/spt/BuatSpt
                this.form.npbu_id = this.npbu_id
                // deklarasi form data
                const formData = new FormData()
                formData.append('tahun', this.form.tahun)
                formData.append('metode_pelaporan', this.form.metode_pelaporan)
                formData.append('jumlah', this.form.jumlah)
                formData.append('ref_rek_6_id', this.form.ref_rek_6_id)
                formData.append('npbu_id', this.form.npbu_id)
                formData.append('dokumen', this.form.dokumen)
                let response = await axios.post('/api/transaksi/spt', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                if (response.data.data) {
                    this.helper.isLoading = false
                    // this.helper.disableButtonSave = true
                    this.helper.editMode = true
                    this.helper.disableButtonNext = false
                    this.$swal({
                        icon: "success",
                        title: "Pendataan Berhasil Dijalankan.",
                        type: "success",
                        showConfirmButton: true,
                        confirmButtonClass: "btn btn-primary",
                        confirmButtonText: "OKE",
                        showCloseButton: true,
                        timer: 5000
                    });
                    this.helper.spt_id = response.data.data.id
                }
            } catch (error) {
                this.helper.isLoading = false
                // this.helper.disableButtonSave = false
                this.helper.editMode = false
                this.helper.disableButtonNext = true
                // console.log(error.response)
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data
                } else if (error.response.status == 401) {
                    // mixins - token clear jika user Unauthorized
                    this.tokenClear()
                }
            }
        },

        async update (spt_id) {
            try {
                this.helper.isLoading = true
                // data form di ambil dari views/transaksi/spt/BuatSpt
                this.form.npbu_id = this.npbu_id
                this.form.dokumen = ''
                // deklarasi form data
                const formData = new FormData()
                formData.append('tahun', this.form.tahun)
                formData.append('metode_pelaporan', this.form.metode_pelaporan)
                formData.append('jumlah', this.form.jumlah)
                formData.append('ref_rek_6_id', this.form.ref_rek_6_id)
                formData.append('npbu_id', this.form.npbu_id)
                formData.append('dokumen', this.form.dokumen)
                formData.append('keterangan', this.form.keterangan)
                formData.append('_method', 'PUT')
                let response = await axios.post(`/api/transaksi/spt/${spt_id}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                if (response.data.data) {
                    this.helper.isLoading = false
                    // this.helper.disableButtonSave = true
                    this.helper.disableButtonNext = false
                    this.$swal({
                        icon: "success",
                        title: "Pendataan Berhasil Dijalankan.",
                        type: "success",
                        showConfirmButton: true,
                        confirmButtonClass: "btn btn-primary",
                        confirmButtonText: "OKE",
                        showCloseButton: true,
                        timer: 5000
                    });
                    this.helper.spt_id = response.data.data.id
                }
            } catch (error) {
                this.helper.isLoading = false
                // this.helper.disableButtonSave = false
                this.helper.disableButtonNext = true
                // console.log(error.response)
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data
                } else if (error.response.status == 401) {
                    // mixins - token clear jika user Unauthorized
                    this.tokenClear()
                }
            }
        },

        // detail spt
        async detailSpt (id) {
            try {
                let response = await axios.get('/api/transaksi/spt/' + id)
                const sptItems = response.data.data
                // console.log(sptItems)
                this.form.fill(sptItems)
                this.helper.nama_rekening = sptItems.ref_rek_6
                this.helper.kode_rekening = sptItems.ref_rek_6.kode
                this.helper.spt_id = sptItems.id
            } catch (error) {
                console.log(error)
            }
        },

        // update dan selesai
        async updateSelesai (spt_id) {
            try {
                this.helper.showLoader = true
                let response = await axios.put(`/api/transaksi/spt/${spt_id}/selesai`)
                // jika request berhasil
                if (response.data.data) {
                    this.helper.showLoader = false
                    this.$swal({
                        title: "Berhasil",
                        text:
                            "Terima kasih telah menyelesaikan laporan pada tahun ini.",
                        icon: "success",
                        showCloseButton: true,
                        showConfirmButton: true,
                        timer: 5000,
                        confirmButtonText: "OKE"
                    });
                    this.$router.push({ name: "Selesai" })
                    localStorage.setItem('spt_id', this.helper.spt_id)
                }
            } catch (error) {
                this.helper.showLoader = false
                console.log(error.response)
                this.$swal({
                    icon: "error",
                    title: "Tejadi Masalah.",
                    html: "Silahkan hubungi Administrator untuk tindakan lebih lanjut. <br>" + "Error: " + error.response.status + '-' + error.response.statusText,
                    type: "success",
                    showConfirmButton: true,
                    confirmButtonClass: "btn btn-primary",
                    confirmButtonText: "OKE",
                    showCloseButton: true,
                    timer: 5000
                });
            }
        }
    }
}

export default spt